import React from 'react'

import { MonitorWeekDayPostCount } from './monitor-weekday-post-count.component'
import { MonitorWeekDayWAU } from './monitor-weekday-wau.component'
import { MonitorWorkDayDAU } from './monitor-workday-dau.component'
import { MonitorWorkDayPostCount } from './monitor-workday-post-count.component'
import s from './monitor.module.less'

export const MonitorContainer = () => {
  return (
    <div className={s.monitorContainer}>
      <MonitorWorkDayDAU />
      <MonitorWorkDayPostCount />
      <MonitorWeekDayWAU />
      <MonitorWeekDayPostCount />
    </div>
  )
}
